import { Link } from "react-router-dom";

const AccessDenied = () => {
    return (
        <div className="flex flex-col items-center justify-center pt-24 gap-4 text-center">
            <h1 className="text-2xl font-semibold">Access Denied</h1>
            <p className="text-muted-foreground">You do not have permission to view this page.</p>
            <Link to="/" className="text-primary underline underline-offset-4">Return Home</Link>
        </div>
    );
};

export default AccessDenied;
